import { useMemo } from "react";
import { useReadContracts } from "wagmi";
import { formatUnits } from "viem";
import { useUserContext } from "../context/UserContext";

const PAYMENT_TOKEN_ADDRESS = process.env.REACT_APP_PAYMENT_TOKEN_ADDRESS;

const ERC20_ABI = [
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "", type: "uint256" }],
  },
];

const usePaymentTokenBalance = () => {
  const { user } = useUserContext();
  const connectedAddress = user?.walletAddress || ""; 
  const enabled = Boolean(PAYMENT_TOKEN_ADDRESS && connectedAddress);

  const { data, isLoading, error } = useReadContracts({
    contracts: enabled
      ? [
          {
            address: PAYMENT_TOKEN_ADDRESS,
            abi: ERC20_ABI,
            functionName: "decimals",
          },
          {
            address: PAYMENT_TOKEN_ADDRESS,
            abi: ERC20_ABI,
            functionName: "balanceOf",
            args: [connectedAddress],
          },
        ]
      : [],
    allowFailure: true,
    query: {
      enabled,
    },
  });

  const decimals = data?.[0]?.result;
  const rawBalance = data?.[1]?.result;

  const balanceString = useMemo(() => {
    if (!enabled || rawBalance == null || decimals == null) return "0";
    try {
      return formatUnits(rawBalance, Number(decimals));
    } catch (_) {
      return "0";
    }
  }, [enabled, rawBalance, decimals]);

  const balanceNumber = useMemo(() => {
    const parsed = Number(balanceString);
    return Number.isFinite(parsed) ? parsed : 0;
  }, [balanceString]);

  return {
    balanceString,
    balanceNumber,
    isLoading,
    error,
  };
};

export default usePaymentTokenBalance;
